@if (appContextService.initializationFailed) {
  <main class="startup-error" data-testid="startup-error" role="alert">
    <h1>{{ 'startupError.title' | translate }}</h1>
    <p>{{ 'startupError.description' | translate }}</p>
    <button type="button" class="btn btn-primary" (click)="retryStartup()">{{ 'startupError.retry' | translate }}</button>
  </main>
} @else {
<router-outlet></router-outlet>

<div class="real-time-blocker" *ngIf="showRealTimeBlocker">
  <div class="real-time-blocker__card">
    <h2>Temps réels à régulariser</h2>
    <p>
      {{ realTimeControl?.message || 'Votre saisie des temps réels n’est pas à jour.' }}
    </p>
    <p class="real-time-blocker__hint">
      L’accès à Vesper est bloqué jusqu’à la régularisation des temps réels manquants.
      Le prévisionnel n’est pas pris en compte.
    </p>
    <div class="real-time-blocker__actions">
      <button class="btn btn-outline-primary" type="button" (click)="goToTimeDeclaration('quick')">
        Saisie rapide
      </button>
      <button class="btn btn-primary" type="button" (click)="goToTimeDeclaration('time')">
        Déclaration de temps
      </button>
    </div>
  </div>
</div>

<app-spinner *ngIf="spinnerState$ | async"></app-spinner>
<app-toasts aria-live="polite" aria-atomic="true"></app-toasts>
<app-bulk-progress-toast></app-bulk-progress-toast>
<!-- <button (click)="throwError()">Show Sentry Error</button> -->

}
